import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

const fetchHistoryStarted = createAction('booking/fetchHistoryStarted');
const fetchHistorySucceeded = createAction('booking/fetchHistorySucceeded');
const fetchHistoryFailed = createAction('booking/fetchHistoryFailed');
const setHistory = createAction('resources/setHistory');

const fetchHistory = () => (dispatch) => {
  dispatch(fetchHistoryStarted());

  return EcomEngineAPI.booking
    .history()
    .then((json) => {
      dispatch(fetchHistorySucceeded());
      dispatch(setHistory(json));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchHistoryFailed(error));
    });
};

export {
  fetchHistoryStarted,
  fetchHistorySucceeded,
  fetchHistoryFailed,
  fetchHistory,
  setHistory,
};
